import { getConfig } from '../../utils/getConfig';

/**
 * Based on the vite env configuration gets the
 * base URL for the API.
 *
 * @returns The base URL for the API
 */
export function getBaseUrl() {
  return getConfig('AUTH0_AUDIENCE');
}
